import { WLANRateSet, CreateWLANBody } from 'features/networkAi/types'

export const noLegacyRateSet: WLANRateSet = {
  '5': {
    template: 'no-legacy',
    min_rssi: 0,
  },
  '6': {
    template: 'no-legacy',
    min_rssi: 0,
  },
  '24': {
    template: 'no-legacy',
    min_rssi: 0,
  },
}

export const defaultRateSet: WLANRateSet = {
  '5': {
    template: 'compatible',
    min_rssi: 0,
  },
  '6': {
    template: 'compatible',
    min_rssi: 0,
  },
  '24': {
    template: 'compatible',
    min_rssi: 0,
  },
}

export const NEW_WLAN_NAME = 'New network'

export const WLANTemplate: CreateWLANBody = {
  ssid: '',
  enabled: true,
  hide_ssid: false,
  hostname_ie: false,
  no_static_ip: false,
  no_static_dns: false,
  bands: [],
  airwatch: {
    enabled: false,
    console_url: '',
    api_key: '',
    username: '',
    password: '',
  },
  disable_wmm: false,
  disable_uapsd: false,
  use_eapol_v1: false,
  auth_servers_nas_id: '',
  auth_servers_nas_ip: '',
  auth_server_selection: 'ordered',
  disable_11ax: true,
  vlan_enabled: false,
  arp_filter: false,
  limit_bcast: false,
  allow_mdns: false,
  allow_ssdp: false,
  allow_ipv6_ndp: true,
  limit_probe_response: false,
  vlan_id: null,
  wxtunnel_remote_id: null,
  wlan_limit_up: 10000,
  wlan_limit_down: 20000,
  client_limit_up: 512,
  client_limit_down: 1000,
  portal: {
    enabled: false,
    bypass_when_cloud_down: true,
    auth: 'none',
    privacy: false,
    external_portal_url: '',
    sso_issuer: '',
    sso_nameid_format: 'email',
    sso_idp_sign_algo: 'sha1',
    sso_idp_cert: '',
    sso_idp_sso_url: '',
    sso_default_role: '',
    sso_forced_role: '',
    password: '',
    expire: 1440,
    forward: false,
    forward_url: '',
    passphrase_enabled: false,
    email_enabled: false,
    sms_enabled: false,
    smsMessageFormat: 'Code {{code}} expires in {{duration}} minutes.',
    sms_provider: 'manual',
    sponsor_enabled: false,
    sponsor_email_domains: [],
    sponsor_link_validity_duration: '60',
    google_enabled: false,
    google_client_id: '',
    google_client_secret: '',
    google_email_domains: [],
    facebook_enabled: false,
    facebook_client_id: '',
    facebook_client_secret: '',
    facebook_email_domains: [],
    amazon_enabled: false,
    amazon_client_id: '',
    amazon_client_secret: '',
    amazon_email_domains: [],
    microsoft_enabled: false,
    microsoft_client_id: '',
    microsoft_client_secret: '',
    microsoft_email_domains: [],
    azure_enabled: false,
    azure_client_id: '',
    azure_client_secret: '',
    azure_tenant_id: '',
    sponsors: [],
    sponsor_notify_all: true,
    predefined_sponsors_enabled: false,
  },
  portal_allowed_subnets: [],
  portal_allowed_hostnames: [],
  portal_denied_hostnames: [],
  portal_api_secret: '',
  cisco_cwa: {
    enabled: false,
    allowed_subnets: [],
    allowed_hostnames: [],
  },
  auth_servers: [],
  acct_servers: [],
  acct_interim_interval: 0,
  schedule: {
    enabled: false,
    hours: {},
  },
  radsec: {
    enabled: false,
    server_name: '',
    servers: [],
  },
  dtim: 2,
  app_qos: {
    enabled: false,
    apps: {},
  },
  auth: {
    type: 'psk',
    enable_mac_auth: false,
    private_wlan: false,
    keys: [null, null, null, null],
    key_idx: 1,
    multi_psk_only: false,
    eap_reauth: false,
    psk: '',
  },
  dynamic_psk: null,
  dynamic_vlan: null,
  dns_server_rewrite: null,
  qos: {
    overwrite: false,
    class: 'best_effort',
  },
  coa_servers: null,
  rateset: {
    5: {
      template: 'compatible',
      min_rssi: 0,
    },
    6: {
      template: 'compatible',
      min_rssi: 0,
    },
    24: {
      template: 'compatible',
      min_rssi: 0,
    },
  },
  app_limit: {
    enabled: false,
    apps: {},
    wxtag_ids: {},
  },
  max_idletime: 1800,
  vlan_pooling: false,
  vlan_ids: [],
  bonjour: {
    enabled: false,
    services: {},
    additional_vlan_ids: '',
  },
  hotspot20: {},
  wxtag_ids: null,
  ap_ids: null,
  apply_to: 'site',
  roam_mode: 'NONE',
  id: '',
  for_site: true,
  template_id: null,
  mxtunnel_id: null,
  wxtunnel_id: null,
  interface: 'all',
}
